import { Component, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { SettingsDTO } from '../../common/types/settings';
import { LiveViewCounterChartDTO, LiveViewDTO } from '../../common/types/common';
import { colors, counterChartMaxData, dashboardChartConfig } from '../../app.config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-live-view-counter',
  templateUrl: './live-view-counter.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LiveViewCounterComponent {
  @Input() liveViewData: LiveViewDTO;
  @Input() liveViewCounterChartData: LiveViewCounterChartDTO;
  @Input() settingsData: SettingsDTO;

  chart: any;

  constructor(private translateService: TranslateService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['liveViewCounterChartData'] && this.liveViewCounterChartData) {
      this.chart = null;
      this.getLiveViewCounterChartData();
    }
  }

  getLiveViewCounterChartData() {
    const chartData = this.liveViewCounterChartData.chartData?.slice(-counterChartMaxData)
    const occupancyData = chartData.map(item => item.count);
    const labels = chartData.map(item => item.time);
    const data = {
      labels: labels,
      datasets: [
        {
          label: this.translateService.instant('STATISTICS.OCCUPANCY_INSIDE'),
          data: occupancyData,
          backgroundColor: colors.secondary,
          fill: true,
          maxBarThickness: 5,
          barPercentage: 0.5
        }
      ]
    };

    const options = {
      ...dashboardChartConfig,
      plugins: {
        ...dashboardChartConfig.plugins,
        legend: {
          display: false
        }
      },
      animation: false,
      scales: {
        x: {
          ticks: {
            display: false
          },
          grid: {
            drawOnChartArea: false,
            drawTicks: false,
            drawBorder: false
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            precision: 0
          }
        }
      }
    }

    this.chart = { type: 'bar', data: data, options: options };
  }

  /*getLiveViewCounterChartData() {
    const TOTAL_SLOTS = 50; // Fixen 50 szeletre osztjuk a teljes szélességet
    const actualData = this.liveViewCounterChartData.chartData?.slice(-TOTAL_SLOTS) || [];

    const missingSlots = TOTAL_SLOTS - actualData.length;
    const leftPadding = Math.floor(missingSlots / 2);
    const rightPadding = Math.ceil(missingSlots / 2);

    // Feltöltjük üres értékekkel a tömb elejét és végét
    const labels = [
      ...Array(leftPadding).fill(''),
      ...actualData.map(item => item.time),
      ...Array(rightPadding).fill('')
    ];

    const occupancyData = [
      ...Array(leftPadding).fill(null),
      ...actualData.map(item => item.count),
      ...Array(rightPadding).fill(null)
    ];
    const data = {
      labels: labels,
      datasets: [
        {
          label: this.translateService.instant('STATISTICS.OCCUPANCY_INSIDE'),
          data: occupancyData,
          backgroundColor: colors.secondary,
          fill: true,
          barThickness: 5 // Fix oszlopszélesség
        }
      ]
    };

    const options = {
      ...dashboardChartConfig,
      scales: {
        x: {
          ticks: {
            display: false
          },
          grid: {
            drawOnChartArea: false,
            drawTicks: false,
            drawBorder: false
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            precision: 0
          }
        }
      }
    }

    this.chart = { type: 'bar', data: data, options: options };
  }*/


  /*getLiveViewCounterChartData() {
    const chartData = this.liveViewCounterChartData.chartData?.slice(-50)
    const occupancyData = chartData.map(item => item.count);
    const labels = chartData.map(item => item.time);
    const data = {
      labels: labels,
      datasets: [
        {
          label: this.translateService.instant('STATISTICS.OCCUPANCY_INSIDE'),
          data: occupancyData,
          backgroundColor: colors.secondary,
          fill: true,
          maxBarThickness: 5
        }
      ]
    };

    if (!this.chart) {
      const options = {
        ...dashboardChartConfig,
        animation: {
          duration: 750,
          easing: 'linear'
        },
        scales: {
          x: {
            ticks: { display: false },
            grid: {
              drawOnChartArea: false,
              drawTicks: false,
              drawBorder: false
            }
          },
          y: {
            beginAtZero: true,
            ticks: { precision: 0 }
          }
        }
      };

      this.chart = { type: 'bar', data: data, options: options };
    } else {
      this.chart = { ...this.chart, data: data };
    }
  }*/
}
